import { render, staticRenderFns } from "./productMain.vue?vue&type=template&id=7ac3d9ed&"
import script from "./productMain.vue?vue&type=script&lang=js&"
export * from "./productMain.vue?vue&type=script&lang=js&"
import style0 from "./productMain.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports